import getAssets from './assets/data/brandingAssets.json';

export const globalConfig = {
    domainName: getAssets.brand.name,
    dataSize: 'GB',
    defaultCurrency: '$',
    libraries: ['places'],
    allowPhoneNumberLength: 16,
    paymentDefaultCurrency: 'usd',
    paymentDefaultCountry: 'US',
    paymentDefaultLabel: 'eSIM Purchase',
    domainUrl: getAssets.emails.domain,
    supportEmail: getAssets.emails.support,
    allowNameLength: 20,
    toastDisplayTime: 5000,
    errorToastDisplayTime:10000000,
    deviceInfo: "website",
    isEsimCompatible: false,
    catalogDataAmountperGB: 1000,
    notificationCount:20,
    privacyPolicy: process.env.REACT_APP_BASE_URL + "/PrivacyPolicy.pdf",
    termsAndConditions: process.env.REACT_APP_BASE_URL + "/Terms&Conditions.pdf",
    payMongoURL: "https://api.paymongo.com/v1",
    iosVersionForActivateEsim: "17.4",
}

export const envConfig = process.env

export const responsiveOptions = [
    {
        breakpoint: "1199px",
        numVisible: 3,
        numScroll: 1
    },
    {
        breakpoint: "991px",
        numVisible: 2,
        numScroll: 1
    },
    {
        breakpoint: "767px",
        numVisible: 1,
        numScroll: 1
    }
];